import React, { Component } from "react";
import "../css/home.css";
import { Grid, Paper, Typography, withStyles, Table, TableHead, TableCell, TableBody, TableRow, Fade, CircularProgress, ListItem, ListItemText, Divider, List, Icon, Chip, IconButton } from "@material-ui/core";
import { ReportService } from "../Services/ReportService";
import moment from "moment";
import { formatNumber, format_date_only_new, format_dm, toInt, format_fancy, convertDistance } from "../Utils";
import CustomDialog from "../components/CustomDialog";
import EnhancedTableToolbar from "../components/EnhancedTableToolbar";
import XLSX from 'xlsx';
import ReturnsSection from "../components/ReturnsSection";
import Config from "../Config";
import TopRankingStates from "./TopRankingStates";
import CardViewBlock from "../components/CardViewBlock";
import CardViewLoader from "../components/CardViewLoader";
import JobStatus from "./JobStatus";
import { ROLES } from "../Roles";

const styles = theme => ({
	root: {
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(2),
		paddingLeft: theme.spacing(3),
		paddingRight: theme.spacing(3),
		overflow: 'auto'
	},
	section: {
		width: '100%',
		minHeight: 453,
		overflow: 'auto',
		overflowX: 'auto',
		paddingTop: theme.spacing(1),
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		paddingBottom: theme.spacing(1)
	},
	list_root: {
		width: '100%',
		maxWidth: 360,
		backgroundColor: theme.palette.background.paper,
	},
	inline: {
		display: 'inline',
	},
	block: {
		minWidth: 142
	}
});

class Home extends Component {

	intervalID;

	constructor(props) {
		super(props);

		props.setTitle('Home to the Happy Cows');

		this.state = {
			rows: [],
			next_day_rows: [],
			fetch_summary_data: true,
			fetch_next_day: true,
			fetch_turn_over: true,
			fetch_returns_over: true,
			startdate: moment().startOf('day').startOf('isoWeek'),
			enddate: moment().startOf('day').endOf('isoWeek'),
			days: 7,
			sales: [],
			total_sales: 0,
			returns: [],
			total_returns: 0,
			dates: [],
			outward_row: [],
			returns_row: [],
			returns_value_row: [],
			dialog: {
				children: [],
				title: undefined,
				open: false
			},
			expecting_from_today: 0,
			expecting_from_tmrw: 0,
			last_refreshed: undefined,
			exportLoading: false,
			refreshStateStats: true,
		}
	}

	componentDidMount() {
		window.addEventListener("focus", this.getData)
		this.getData();
		this.intervalID = setInterval(this.getData.bind(this), Config.REFRESH_INTERVAL);
	}

	componentWillUnmount() {
		window.removeEventListener("focus", this.getData);
		clearInterval(this.intervalID);
	}

	getData = () => {
		let dates = [];
		let date = moment(this.state.startdate);
		while (date.isSameOrBefore(moment(this.state.enddate))) {
			dates.push(date);
			date = moment(date).add(1, 'day');
		}
		this.setState({
			startdate: moment().startOf('isoWeek'),
			enddate: moment().endOf('isoWeek'),
			dates
		},
			() => {
				this.props.refreshStats();
				this.props.isLoading(false);
				this.fetchdata();
				this.fetchTurnoverSummary();
				this.fetchReturnValueSummary();
				this.fetchNextDayImport();
				this.setState({ refreshStateStats: true });
			});
	}

	fetchTurnoverSummary = () => {
		ReportService.turnoverSummary(moment().diff(this.state.startdate, 'days') - 1, this.state.startdate, this.state.enddate)
			.then((data) => {
				// console.log(data);
				let outward_row = [], sales = [];
				let total_amount = 0;
				outward_row.push(<Typography display="block" key={"OUTWARD"} className={this.props.classes.typography} variant="h6">Sales</Typography>);
				if (data.summary.length > 0) {
					total_amount = data.summary.reduce(function (accumulator, currentValue) {
						return accumulator + parseFloat(currentValue.total_amount);
					}, total_amount);


					data.summary.forEach((element, index) => {
						sales.push({ date: moment(element.schedule_date), amount: element.total_amount });
						outward_row.push(<Typography display="block" align="center" key={"OUTWARD" + index} className={this.props.classes.typography} variant="body2" style={{ marginLeft: 20 }}>{moment(element.schedule_date).format(format_date_only_new)} | {formatNumber(element.total_amount)}</Typography>)
					});
				}
				outward_row.push(<Typography display="block" align="center" key={"OUTWARD_TOTAL"} className={this.props.classes.typography} variant="h6" color="primary" style={{ marginLeft: 20, marginTop: 10, marginBottom: 30 }}>Total: {formatNumber(total_amount)}</Typography>);
				this.setState({ fetch_turn_over: false, outward_row, sales, total_sales: total_amount });
			});
	}

	fetchReturnValueSummary = () => {
		ReportService.returnsValueSummary(moment().diff(this.state.startdate, 'days') - 1, this.state.startdate, this.state.enddate)
			.then((data) => {
				// console.log(data);
				let returns_value_row = [], returns = [];
				let total_amount = 0;
				returns_value_row.push(<Typography display="block" key={"RETURNS"} className={this.props.classes.typography} variant="h6">Returns</Typography>);
				if (data.summary.length > 0) {
					total_amount = data.summary.reduce(function (accumulator, currentValue) {
						return accumulator + parseFloat(currentValue.total_amount);
					}, total_amount);

					data.summary.forEach((element, index) => {
						returns.push({ date: moment(element.schedule_date), amount: element.total_amount });
						returns_value_row.push(<Typography display="block" align="center" key={"RETURNS" + index} className={this.props.classes.typography} variant="body2" style={{ marginLeft: 20 }}>{moment(element.schedule_date).format(format_date_only_new)} | {formatNumber(element.total_amount)}</Typography>)
					});
				}
				returns_value_row.push(<Typography display="block" align="center" key={"OUTWARD_TOTAL"} className={this.props.classes.typography} variant="h6" color="primary" style={{ marginLeft: 20, marginTop: 10, marginBottom: 30 }}>Total: {formatNumber(total_amount)}</Typography>);
				this.setState({ fetch_returns_over: false, returns_value_row, returns, total_returns: total_amount });
			});
	}

	handleClose = () => {
		this.setState({ dialog: { open: false, children: [], title: undefined } });
	}

	exportReport = () => {
		this.setState({ exportLoading: true });
		ReportService.routeSummaryExport(moment())
			.then((data) => {
				console.log(data);
				if (data.rows && data.rows.length > 0) {
					let sheetname = 'Delivery Report';
					let exportStoreData = [];
					let title = data.title;
					exportStoreData = [title];
					data.rows.forEach((row) => {
						exportStoreData.push(row);
					});

					if (exportStoreData) {
						const wb = XLSX.utils.book_new();
						const wsAll = XLSX.utils.aoa_to_sheet(exportStoreData);
						XLSX.utils.book_append_sheet(wb, wsAll, sheetname);
						XLSX.writeFile(wb, sheetname + ".xlsx");
					}
				} else {
					this.props.showSnackBar('Nothing to export', 'error');
				}
				this.setState({ exportLoading: false });
			})
			.catch((error) => {
				this.setState({ exportLoading: false });
			});
	}

	openDialog = (element, date) => event => {
		if (event) {
			event.preventDefault();
		}

		ReportService.routeSummaryDetailed(date, element.route_id)
			.then((data) => {
				console.log(data);
				let children = [], rows = [];

				data.summary.forEach((element, index) => {
					let away = parseFloat(element.away);
					rows.push(
						<ListItem alignItems="flex-start" key={index}>
							<ListItemText
								primary={element.store_name}
								secondary={
									<React.Fragment>
										<Typography
											component="span"
											variant="body2"
											className={this.props.classes.inline}
											color={element.pending_count && toInt(element.pending_count) > 0 ? "secondary" : (element.completed_count && toInt(element.completed_count) > 0 ? "primary" : "textSecondary")}
										>
											{element.pending_count && toInt(element.pending_count) > 0 ? "Pending" : (element.completed_count && toInt(element.completed_count) > 0 ? "Completed" : "")} {(element.completed_count && toInt(element.completed_count) > 0 ? ` - ${formatNumber(element.amount)}` : "")}
											<br/>{(!element.pending_count || toInt(element.pending_count) === 0) ? (away >= 0 ? <Chip label={`${convertDistance(away)} Away`} size="small" color={away > 50 ? "secondary" : "primary"} variant={away > 50 ? "default" : "outlined"} /> : <Chip label="Not available" variant="outlined" size="small" color="secondary" />) : ""}
										</Typography>
										<br />
										{this.props.modules_enabled.b2b_module && element.last_amount && <span><Icon color={parseFloat(element.last_amount) < parseFloat(element.amount) ? "primary" : "secondary"} >{parseFloat(element.last_amount) < parseFloat(element.amount) ? "arrow_upward" : "arrow_downward"}</Icon>Last sale {formatNumber(element.last_amount)}</span>}
									</React.Fragment>
								}
							/>
						</ListItem>
					);
					rows.push(<Divider variant="fullWidth" component="li" key={index + "DIVIDER"} />);
				});

				children.push(<List key={"list"} className={this.props.classes.list_root}>{rows}</List>);

				this.setState({ dialog: { open: true, children, title: "Route Details" } });
			});
	}

	fetchdata = () => {
		let rows = [];
		let date = moment();
		let expecting_from_today = 0;
		ReportService.routeSummary(moment())
			.then((data) => {
				// console.log(data);
				if (data.summary.pending.length > 0 || data.summary.completed.length > 0) {
					let pendingList = [];
					data.summary.pending.forEach(element => {
						let c_list = data.summary.completed.filter(d => d.route_id === element.route_id);
						let completed = c_list.length > 0 ? c_list[0].count : 0;
						let revenue = c_list.length > 0 ? c_list[0].amount : 0;
						expecting_from_today += parseFloat(element.amount);
						pendingList.push(element.route_id);
						rows.push(
							<TableRow key={element.route_id} style={{ cursor: "pointer" }} onClick={this.openDialog(element, date)}>
								<TableCell>
									{element.route_id}
								</TableCell>
								<TableCell>
									{element.agent_name}
								</TableCell>
								<TableCell>
									{completed ? completed : 0}
								</TableCell>
								<TableCell style={{ color: parseInt(element.count) === 0 ? "" : "red" }}>
									{element.count}
								</TableCell>
								{
									this.props.modules_enabled.b2b_module && (
										<TableCell align="right">
											{formatNumber(revenue)}
										</TableCell>
									)
								}
							</TableRow>
						);
					});
					data.summary.completed.filter(p => !pendingList.includes(p.route_id)).forEach(element => {
						rows.push(
							<TableRow key={element.route_id} style={{ cursor: "pointer" }} onClick={this.openDialog(element, date)}>
								<TableCell>
									{element.route_id}
								</TableCell>
								<TableCell>
									{element.agent_name}
								</TableCell>
								<TableCell>
									{element.count}
								</TableCell>
								<TableCell>
									{0}
								</TableCell>
								{
									this.props.modules_enabled.b2b_module && (
										<TableCell align="right">
											{formatNumber(element.amount)}
										</TableCell>
									)
								}
							</TableRow>
						);
					});
				} else {
					rows.push(
						<TableRow key={1}>
							<TableCell colSpan="3">
								<Typography variant="caption">No schedules available</Typography>
							</TableCell>
						</TableRow>);
				}
				this.setState({ fetch_summary_data: false, rows, expecting_from_today, last_refreshed: moment() });
			})
	}

	fetchNextDayImport = () => {
		let next_day_rows = [];
		let date = moment().add("1", "day");
		let expecting_from_tmrw = 0;
		ReportService.routeSummary(date)
			.then((data) => {
				console.log(data);
				if (data.summary.pending.length > 0) {

					data.summary.pending.forEach(element => {
						expecting_from_tmrw += parseFloat(element.amount);
						next_day_rows.push(<TableRow key={element.route_id} style={{ cursor: "pointer" }} onClick={this.openDialog(element, date)}>
							<TableCell>
								{element.route_id}
							</TableCell>
							<TableCell>
								{element.agent_name}
							</TableCell>
							<TableCell>
								{element.count}
							</TableCell>
						</TableRow>);
					});
				} else {
					next_day_rows.push(
						<TableRow key={1}>
							<TableCell colSpan="2">
								<Typography variant="caption">No schedules available</Typography>
							</TableCell>
						</TableRow>);
				}
				this.setState({ fetch_next_day: false, next_day_rows, expecting_from_tmrw });
			})
	}

	render() {
		let { classes } = this.props;
		let { exportLoading, last_refreshed, dialog, expecting_from_today, expecting_from_tmrw, rows, next_day_rows, fetch_turn_over, fetch_returns_over, fetch_summary_data, fetch_next_day, startdate, enddate, sales, total_sales, returns, total_returns, dates } = this.state;
		return (
			<div className="Home">
				<div className="">
					<div style={{ float: "right", marginTop: 25 }}>
						<Typography variant="caption">
							Last Refreshed: {last_refreshed && last_refreshed.format(format_fancy)}
						</Typography>
						<IconButton aria-label="close" onClick={this.getData}>
							<Icon>refresh</Icon>
						</IconButton>
					</div>
					<Grid container spacing={2} style={{ marginTop: 20 }}>
						<Grid container item data-tour="today" spacing={0} xs={12} lg={12} xl={12} alignItems="center" justify="center">
							<Grid item lg={2} xs={12}>
								<CardViewBlock
									title={`${moment(startdate).format(format_dm)} - ${moment(enddate).format(format_dm)}`}
									subtitle={`Total Sales ${formatNumber(total_sales)}`}
									thirdrow={this.props.modules_enabled.b2b_module ? `Total Returns ${formatNumber(total_returns)}` : undefined}
									thirdrowcolor='red' />
							</Grid>
							{
								dates.map((date, index) => {
									let sale = sales.find(s => moment(s.date).startOf('day').isSame(date));
									let returnRow = returns.find(s => moment(s.date).startOf('day').isSame(date));
									return (
										<Grid key={index} item>
											{
												fetch_turn_over && fetch_returns_over ?
													<CardViewLoader />
													:
													<CardViewBlock
														className={classes.block}
														title={date.format(format_dm)}
														subtitle={sale ? formatNumber(sale.amount || 0) : '-'}
														thirdrow={this.props.modules_enabled.b2b_module && sale && returnRow ? formatNumber(returnRow.amount || 0) : ''}
														thirdrowcolor='red' />
											}
										</Grid>
									);
								})
							}
						</Grid>
						<Grid item lg={this.props.modules_enabled.b2b_module ? 7 : 6} xs={12}>
							<TopRankingStates refresh={this.state.refreshStateStats} onRefreshFinish={() => this.setState({ refreshStateStats: false })} />
						</Grid>
						{
							this.props.modules_enabled.b2b_module && (
								<Grid item lg={5} xs={12}>
									<ReturnsSection showProgress={true} startdate={this.state.startdate} enddate={this.state.enddate} sectionStyle={classes.section} title="RETURNS" />
								</Grid>
							)
						}
						<Grid item lg={6} xs={12}>
							<Paper className={classes.root}>
								<EnhancedTableToolbar title="Today's Delivery Status" exportReport={this.exportReport} showProgress loading={exportLoading} />
								<Table size="small">
									<TableHead>
										<TableRow>
											<TableCell>
												<Typography variant="subtitle2">Route</Typography>
											</TableCell>
											<TableCell>
												<Typography variant="subtitle2">Agent</Typography>
											</TableCell>
											<TableCell>
												<Typography variant="subtitle2">Completed</Typography>
											</TableCell>
											<TableCell>
												<Typography variant="subtitle2">Pending</Typography>
											</TableCell>
											{
												this.props.modules_enabled.b2b_module && (
													<TableCell align="right">
														<Typography variant="subtitle2">Revenue from Completed</Typography>
													</TableCell>
												)
											}
										</TableRow>
									</TableHead>
									<TableBody>
										{rows}
									</TableBody>
								</Table>
								{
									this.props.modules_enabled.b2b_module && (
										<Typography color="textSecondary" variant="body1" style={{ "marginTop": 10 }}>Expected Revenue from remaining deliveries: <b>{formatNumber(expecting_from_today)}</b></Typography>
									)
								}
								<Fade
									in={fetch_summary_data}
									style={{
										transitionDelay: fetch_summary_data ? '10ms' : '0ms'
									}}
									unmountOnExit
								>
									<CircularProgress style={{ marginTop: 20 }} />
								</Fade>
							</Paper>
						</Grid>
						<Grid item lg={6} xs={12}>
							<Paper className={classes.root}>
								<Typography variant="h6">Schedules for Tomorrow</Typography>
								<Table size="small">
									<TableHead>
										<TableRow>
											<TableCell>
												<Typography variant="subtitle2">Route</Typography>
											</TableCell>
											<TableCell>
												<Typography variant="subtitle2">Agent</Typography>
											</TableCell>
											<TableCell>
												<Typography variant="subtitle2">Count</Typography>
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{next_day_rows}
									</TableBody>
								</Table>
								{
									this.props.modules_enabled.b2b_module && (
										<Typography color="textSecondary" variant="body1" style={{ "marginTop": 10 }}>Expected Revenue: <b>{formatNumber(expecting_from_tmrw)}</b></Typography>
									)
								}
								<Fade
									in={fetch_next_day}
									style={{
										transitionDelay: fetch_next_day ? '10ms' : '0ms'
									}}
									unmountOnExit
								>
									<CircularProgress style={{ marginTop: 20 }} />
								</Fade>
							</Paper>
						</Grid>
						{
							this.props.modules_enabled.b2b_module && (
								<Grid item lg={6} xs={12}>
									<JobStatus title="B2B Scheduler" isAdmin={this.props.user.roles.includes(ROLES.ADMIN)} {...this.props} />
								</Grid>
							)
						}
					</Grid>
					<CustomDialog title={dialog.title} buttonText={"CLOSE"} handleClose={this.handleClose} open={dialog.open}>
						{dialog.children}
					</CustomDialog>
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(Home);
